/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/putOnHoldModal/services"/>
import { post } from "Core/Medius.Core.Web/Scripts/Medius/core/fetch/rest";
import { PutOnHoldReasonsDto } from "./interfaces";

export async function postPutOnHoldCodesDto(putOnHoldCodesDto: PutOnHoldReasonsDto): Promise<number> {
    return post("remedium-api/apa/reasonCodeOperationManagement/onHold", putOnHoldCodesDto);
}